import Component from '@glimmer/component';
import { t } from 'ember-intl';
import WChangePasswordForm from 'login/components/w-change-password-form';
import WLoginDialog from 'login/components/w-login-dialog';
import type { ApplicationModel } from 'login/routes/application';

export default class SetPassword extends Component<{ Args: { model: ApplicationModel } }> {
  private get action(): string {
    return `setPassword${window.location.search}`;
  }

  <template>
    <WLoginDialog
      @pageTitle={{t 'login.title.setPassword'}}
      @dialogTitle={{@model.logonParams.serviceName}}
      @version={{@model.version}}
    >
      <WChangePasswordForm
        action={{this.action}}
        @loginActionPasswordText='login.setPasswordText'
        @loginActionPasswordLabel='login.createPasswordLabel'
        @loginActionPasswordButton='login.setPasswordButton'
      />
    </WLoginDialog>
  </template>
}
